import ContractsCargoTaxiAddParams from "../../../../../common/services/contracts/cargo-taxi/add/contracts-cargo-taxi-add-params";
import TaxiCargoContractAddFormData from "./types/taxi-cargo-contract-add-form-data";

const create = (
  formData: TaxiCargoContractAddFormData,
  taxiCorporationUuid: string,
): ContractsCargoTaxiAddParams => {
  return {
    billingModel: formData.billingModel!,
    cargoCompanyUuid: formData.cargoCompanyUuid,
    discountPercentLimit: formData.discountPercentLimit!,
    distanceRate: formData.distanceRate!,
    freeStoppingPeriodMinutes: formData.freeStoppingPeriodMinutes!,
    isActive: formData.isActive!,
    isOrderPublishingAllowed: formData.isOrderPublishingAllowed!,
    isTollRoadsDuringOrderAllowed: formData.isTollRoadsDuringOrderAllowed!,
    isTollRoadsWhileArrivalAllowed: formData.isTollRoadsWhileArrivalAllowed!,
    isTollRoadsWhileReturningAllowed:
      formData.isTollRoadsWhileReturningAllowed!,
    periodOfValidity: formData.periodOfValidity!,
    stoppingRate: formData.stoppingRate!,
    taxiCorporationUuid,
    contactPassengerAfterMinutes: formData.contactPassengerAfterMinutes!,
    cancelOrderByTaxiAllowed: formData.cancelOrderByTaxiAllowed!,
    editOrderByTaxiAllowed: formData.editOrderByTaxiAllowed!,
    autoApprovalSwitch: formData.autoApprovalSwitch,
    autoApprovalMinDistance: formData.autoApprovalSwitch
      ? formData.autoApprovalMinDistance
      : 0,
    autoApprovalMinTime: formData.autoApprovalSwitch
      ? formData.autoApprovalMinTime
      : 0,
    approvalDeadlineSwitch: formData.approvalDeadlineSwitch,
    approvalDeadlineTime: formData.approvalDeadlineSwitch
      ? formData.approvalDeadlineTime
      : 0,
  };
};

const taxiCargoContractAddParamsFactory = {
  create,
};

export default taxiCargoContractAddParamsFactory;
